import { useParams } from "react-router-dom";
import { useState } from "react";
import dayjs from "dayjs";
import ServiceDetailView from "./ServiceDetailView";

const DetailedServicePerformanceView = () => {
  const { serviceName } = useParams();
  const [dateRange, setDateRange] = useState({
    startDate: dayjs().startOf("month").toDate(),
    endDate: dayjs().endOf("month").toDate(),
  });

  // Decode the service name from URL and create service object
  const service = {
    id: decodeURIComponent(serviceName),
    name: decodeURIComponent(serviceName),
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleExport = () => {
    // TODO: Implement export functionality
  };

  const handleDateChange = (range) => {
    setDateRange(range);
  };

  return (
    <ServiceDetailView
      service={service}
      onBack={handleBack}
      onExport={handleExport}
      dateRange={dateRange}
      onDateChange={handleDateChange}
    />
  );
};

export default DetailedServicePerformanceView;
